import React from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../actions';
import Navbar from './navbar/Navbar';
import Sidebar from './sidebar/Sidebar';
import LoaderModal from '../modal/LoaderModal';
//import $ from 'jquery';
class Dashboard extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isFetching: false
        }
    }
    async componentDidMount(){
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
    }    

    render(){
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title="Dashboard" />
                    
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Dashboard);